import { mapRasseTkv } from '@ps20-frontend/migrations';
import { Versicherungsnehmer } from '../reducers/versicherungsnehmer.reducer';
import { StatePreV10, StateV10 } from './10_migrate_rasse_pyrenaeen.interface';

export const migrateRassePyrenaeen = (previousState: StatePreV10, newVersion: number): StateV10 => {
  return {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      rasse: previousState.versicherungsnehmer?.rasse
        ? {
            ...previousState.versicherungsnehmer.rasse,
            value: mapRasseTkv(previousState.versicherungsnehmer.rasse.value),
          }
        : previousState.versicherungsnehmer?.rasse,
    } as Versicherungsnehmer,
  };
};
